//文字コードはutf-8

/* 共通モーダル
========================================================*/

export function initModal() {
    // モーダルDOM生成
    const overlay = document.createElement('div');
    overlay.className = 'modModalOverlay jsModalOverlay';
    overlay.setAttribute('aria-hidden', 'true');

    const content = document.createElement('div');
    content.className = 'modModalContent jsModalContent';
    content.setAttribute('role', 'dialog');
    content.setAttribute('aria-modal', 'true');

    const closeBtn = document.createElement('button');
    closeBtn.className = 'modModalContent__close jsModalClose';
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', '閉じる');

    const inner = document.createElement('div');
    inner.className = 'modModalContent__inner jsModalInner';

    content.appendChild(closeBtn);
    content.appendChild(inner);
    document.body.appendChild(overlay);
    document.body.appendChild(content);

    function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

    function openModal(triggerEl) {
        var type = triggerEl.getAttribute('data-modal-type');

        // タイプ別コンテンツ注入
        if (type === 'video') {
            var src = triggerEl.getAttribute('data-modal-src');
            if (src) {
                var iframe = document.createElement('iframe');
                iframe.src = src;
                iframe.setAttribute('allow', 'autoplay; encrypted-media');
                iframe.setAttribute('allowfullscreen', '');
                iframe.setAttribute('frameborder', '0');
                iframe.title = triggerEl.getAttribute('aria-label') || '動画';
                inner.appendChild(iframe);
            }
            content.classList.add('modModalContent--video');
        } else if (type === 'content') {
            var targetSelector = triggerEl.getAttribute('data-modal-target');
            if (targetSelector) {
                var sourceEl = document.querySelector(targetSelector);
                if (sourceEl) {
                    inner.appendChild(sourceEl.cloneNode(true));
                    inner.lastChild.removeAttribute('hidden');
                }
            }
            content.classList.add('modModalContent--content');
        } else if (type === 'image') {
            var imgSrc = triggerEl.getAttribute('data-modal-src');
            if (imgSrc) {
                var img = document.createElement('img');
                img.src = imgSrc;
                img.alt = triggerEl.getAttribute('aria-label') || '';
                inner.appendChild(img);
            }
            content.classList.add('modModalContent--image');
        }

        // スクロールバー幅を計算してガタつき防止
        var scrollbarWidth = getScrollbarWidth();
        document.body.style.paddingRight = scrollbarWidth + 'px';
        document.body.style.overflow = 'hidden';

        overlay.classList.add('is-active');
        overlay.setAttribute('aria-hidden', 'false');
        content.classList.add('is-active');
    }

    function closeModal() {
        overlay.classList.remove('is-active');
        overlay.setAttribute('aria-hidden', 'true');
        content.classList.remove('is-active');

        // transitionend後にコンテンツをクリアしスクロール復元
        content.addEventListener('transitionend', function handler() {
            content.removeEventListener('transitionend', handler);
            inner.innerHTML = '';
            content.classList.remove('modModalContent--video', 'modModalContent--content', 'modModalContent--image');
            document.body.style.paddingRight = '';
            document.body.style.overflow = '';
        });
    }

    // トリガークリック（イベント委任で動的要素にも対応）
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.jsModalOpen');
        if (trigger) {
            e.preventDefault();
            openModal(trigger);
        }
    });

    // 閉じる：overlay
    overlay.addEventListener('click', closeModal);

    // 閉じる：closeボタン
    closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeModal();
    });

    // 閉じる：Escapeキー
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
            closeModal();
        }
    });
}
